import browserUpdate from 'browser-update';
import { Platform } from 'quasar';

export default ({ app, router, Vue }) => {
    // Only run browser-update for non-Capacitor builds
    // Capacitor builds uses the WebView browser, which cannot be updated
    // unless the mobile OS is updated.
    if (!Platform.is.capacitor) {
        browserUpdate({
            required: { e: -10, f: -10, o: -10, s: -10, c: -10 },
            // This is the version of the browser-update api to use. Please do not remove.
            api: 2024.08,
            // after how many hours should the message reappear
            reminder: 24,
            // Give the user the option to permanently hide the notification
            no_permanent_hide: false,
            // Notify all browser that are severely insecure
            insecure: true
        });
    }
};
